export const INVAILD_VALUE = {
name : 'Please enter a valid name',
ip_address : 'Please enter a valid email'
}